import React, { createContext, useEffect, useState } from 'react';
import { BreadcrumbsManager } from './BreadcrumbsManager';

// Define breadcrumb item shape
export interface BreadcrumbItem {
  label: string;
  href: string;
}

// Define context type
export interface BreadcrumbsContextType {
  breadcrumbs: BreadcrumbItem[];
}

// Create the context with a default value
export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  breadcrumbs: [],
});

// Context Provider
export const BreadcrumbsProvider = ({ children }: { children: React.ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  useEffect(() => {
    // Initialize BreadcrumbsManager handlers
    BreadcrumbsManager.init(
      (item: BreadcrumbItem) => {
        setBreadcrumbs((prev) => [...prev, item]);
        BreadcrumbsManager.breadcrumbs = [...BreadcrumbsManager.breadcrumbs, item];
      },
      () => {
        setBreadcrumbs((prev) => prev.slice(0, -1));
        BreadcrumbsManager.breadcrumbs = BreadcrumbsManager.breadcrumbs.slice(0, -1);
      },
      () => {
        setBreadcrumbs([]);
        BreadcrumbsManager.breadcrumbs = [];
      },
      (items: BreadcrumbItem[]) => {
        setBreadcrumbs(items);
        BreadcrumbsManager.breadcrumbs = [...items];
      },
    );
  }, []);

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs }}>{children}</BreadcrumbsContext.Provider>
  );
};
